import { GameCard } from "@/entities/game";
import { SearchInput } from "@/features/filter";
import { useApps, useDebounce, useGameFilter } from "@/shared/hooks";
import LoaderDotSpinner from "@/shared/ui/Loaders/Loaders";
import { GameLayout } from "@/widgets/layout";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./HomePage.module.css";

export const HomePage: React.FC = observer(() => {
  
  const navigate = useNavigate();
  const { otp } = useParams<{ otp: string }>();

  useEffect(() => {
    if (otp) {
      console.log("otp", otp);
      navigate(`/verify?otp=${otp}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  const {
    // filterValues,
    searchQuery,
    setSearchQuery,
    // setFilterValue,
    // applyFilters,
    // resetFilters,
    // activeFilters,
    // hasActiveFilters,
  } = useGameFilter();

  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const {
    data: apps,
    isLoading,
    error,
    refetch,
  } = useApps(debouncedSearchQuery);

  // const filteredApps = useMemo(() => {
  //   if (!apps) return apps;

  //   const filtered = [...apps];

  //   if (activeFilters.category && Array.isArray(activeFilters.category)) {
  //     // Здесь можно добавить реальную фильтрацию по категориям
  //   }

  //   if (activeFilters.status) {
  //     // Фильтрация по статусу
  //   }

  //   if (activeFilters.sortBy) {
  //     switch (activeFilters.sortBy) {
  //       case "title_asc":
  //         filtered.sort((a, b) => a.title.localeCompare(b.title));
  //         break;
  //       case "title_desc":
  //         filtered.sort((a, b) => b.title.localeCompare(a.title));
  //         break;
  //       case "date_desc":
  //         filtered.sort(
  //           (a, b) =>
  //             new Date(b.created_at).getTime() -
  //             new Date(a.created_at).getTime()
  //         );
  //         break;
  //       case "date_asc":
  //         filtered.sort(
  //           (a, b) =>
  //             new Date(a.created_at).getTime() -
  //             new Date(b.created_at).getTime()
  //         );
  //         break;
  //     }
  //   }

  //   return filtered;
  // }, [apps, activeFilters]);

  if (isLoading) {
    return (
      <GameLayout isCompact={true}>
        <div className={styles.loadingContainer}>
          <div className={styles.loadingContent}>
            <LoaderDotSpinner />
            <p className={styles.loadingText}>Загрузка игр...</p>
            <p className={styles.loadingSubtext}>Пожалуйста, подождите</p>
          </div>
        </div>
      </GameLayout>
    );
  }

  if (error) {
    return (
      <GameLayout>
        <div className={styles.errorContainer}>
          <div className={styles.errorContent}>
            <h2 className={styles.errorTitle}>Ошибка загрузки</h2>
            <p className={styles.errorText}>Не удалось загрузить список игр</p>
            <button onClick={() => refetch()} className={styles.errorButton}>
              Попробовать снова
            </button>
          </div>
        </div>
      </GameLayout>
    );
  }

  return (
    <GameLayout>
      <div className={styles.container}>
        <div className={styles.content}>
          <div
            className={styles.searchContainer}
            style={{ animationDelay: "300ms" }}
          >
            <div className={styles.searchWrapper}>
              <SearchInput
                value={searchQuery}
                onChange={setSearchQuery}
                placeholder="Поиск игр..."
              />
              {/* <GameFilter
              fields={gameFilterConfig}
              values={filterValues}
              onFilterChange={setFilterValue}
              onApply={applyFilters}
              onReset={resetFilters}
              hasActiveFilters={hasActiveFilters}
            /> */}
            </div>
          </div>

          <div
            className={styles.filterContainer}
            style={{ animationDelay: "400ms" }}
          ></div>

          {apps && apps.length > 0 ? (
            <div className={styles.gamesGrid}>
              {apps.map((app, index) => (
                <div
                  key={app.id}
                  className={styles.gameCard}
                  style={{
                    animationDelay: `${600 + index * 100}ms`,
                  }}
                >
                  <GameCard
                    title={app.title}
                    description={app.short_description}
                    image={app.thumbnail || ""}
                    slug={app.slug}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div
              className={styles.emptyState}
              style={{ animationDelay: "600ms" }}
            >
              {searchQuery ? (
                <>
                  <h3
                    className={`${styles.emptyTitle} ${styles.emptyTitleNotFound}`}
                  >
                    Ничего не найдено
                  </h3>
                  <p className={styles.emptyText}>
                    По запросу "{searchQuery}" игры не найдены
                  </p>
                  <p className={styles.emptyHint}>
                    Попробуйте изменить поисковый запрос
                  </p>
                  <button
                    onClick={() => setSearchQuery("")}
                    className={styles.emptyButton}
                  >
                    Очистить поиск
                  </button>
                </>
              ) : (
                <>
                  <h3
                    className={`${styles.emptyTitle} ${styles.emptyTitleNoGames}`}
                  >
                    Игры не найдены
                  </h3>
                  <p className={styles.emptyText}>
                    В данный момент нет доступных игр
                  </p>
                  <p className={styles.emptyHint}>
                    Попробуйте обновить страницу позже
                  </p>
                  <button
                    onClick={() => refetch()}
                    className={styles.emptyButtonGray}
                  >
                    Обновить
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </GameLayout>
  );
});
